import { TromanError } from "@/common/TromanError";
import { OwnerType } from "@/twapp/server/FileEndpoint";
import _ from "lodash";
import { IContainer, IEntry, IFile, IFileRoot, IFolder, isFolder } from "./fileModel";
import { FileInfo } from "@/twapp/objects/FileInfo";

function createFolder(basepath: string, src: FileInfo): IFolder {
    return ({ 
        type: 'folder',
        id: src.Id,
        source: src,
        name: src.Filename,
        fullPath: `${basepath}${src.Filename}`,
        files: [],
        folders: [],
        totalFolderCount: 0,
        totalFileCount: 0,
        totalPublikCount: 0,
        totalPolitikerCount: 0,
    });
}

function createFile(basepath: string, src: FileInfo): IFile {
    return ({
        type: 'file',
        id: src.Id,
        source: src,
        name: src.Filename,
        fullPath: `${basepath}${src.Filename}`,
        showPolitiker: src.ShowPolitiker,
        showPublik: src.ShowPublik,
    });
}

function compareEntry(a: IEntry, b: IEntry) {
    return a.name.localeCompare(b.name, 'sv-SE', { numeric: true });
}

function computeStats(cont: IContainer) {
    cont.totalFolderCount = cont.folders.length;
    cont.totalFileCount = cont.files.length;
    cont.totalPolitikerCount = 0;
    cont.totalPublikCount = 0;
    for (let file of cont.files) {
        if (file.showPolitiker) {
            cont.totalPolitikerCount += 1;
        }
        if (file.showPublik) {
            cont.totalPublikCount += 1;
        }
    }
    for (let folder of cont.folders) {
        computeStats(folder);
        cont.totalFolderCount += folder.totalFolderCount;
        cont.totalFileCount += folder.totalFileCount;
        cont.totalPolitikerCount += folder.totalPolitikerCount;
        cont.totalPublikCount += folder.totalPublikCount;
    }
}

export function parseFileRoot(ownerId: string, ownerType: OwnerType, fileInfos: FileInfo[]) {
    
    const result: IFileRoot = {
        folders: [],
        files: [],
        ownerId: ownerId,
        ownerType: ownerType,
        totalFolderCount: 0,
        totalFileCount: 0,
        totalPublikCount: 0,
        totalPolitikerCount: 0,
    };

    const containersById = new Map<string, IFileRoot|IFolder>([['ROOT', result]]);
    const infosByParent = _.groupBy(fileInfos, x => x.FolderId || 'ROOT');
    const remaining = ['ROOT'];
    while (remaining.length > 0) {
        const parentId = remaining.pop()!;

        const parent = containersById.get(parentId);
        if (parent == null) {
            throw new TromanError('invalid_file_hierarchy');
        }

        const children = infosByParent[parentId];
        if (children) {
            const basePath = isFolder(parent) ? parent.fullPath + '/' : '';
            for (let child of children) {
                if (child.IsFolder) {
                    const folder = createFolder(basePath, child)
                    remaining.push(child.Id);
                    containersById.set(child.Id, folder);
                    parent.folders.push(folder);
                } else {
                    parent.files.push(createFile(basePath, child));
                }
            }
        }
    }

    for (let container of containersById.values()) {
        container.files.sort(compareEntry);
        container.folders.sort(compareEntry);
    }

    computeStats(result);
    
    return result;
}
